export default __webpack_public_path__ + "static/media/restore-file.f0abad00.svg";